import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMaterialItemQueryVariables = Types.Exact<{
  materialItemId: Types.Scalars['String']['input'];
}>;


export type GetMaterialItemQuery = { __typename?: 'Query', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null };

export type GetMaterialItemsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialItemDocumentSortInput> | Types.MaterialItemDocumentSortInput>;
}>;


export type GetMaterialItemsQuery = { __typename?: 'Query', materialItems?: { __typename?: 'MaterialItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProduceTagsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.MaterialItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialItemDocumentSortInput> | Types.MaterialItemDocumentSortInput>;
}>;


export type GetProduceTagsQuery = { __typename?: 'Query', produceTags?: { __typename?: 'ProduceTagsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialItemDocument', erpId: string, id: string, quantityOnHand?: number | null, status: Types.MaterialItemStatus, updated: Types.TDateISO, tag?: { __typename?: 'MaterialItemTagData', category?: string | null, color?: string | null, customerName?: string | null, description?: string | null, extraCodes: Array<string>, fulfillItemCode?: string | null, genus?: string | null, retail?: number | null, series?: string | null, source: Types.ProduceTagSource, sku?: string | null, tagCode: string, tagId?: string | null, tagType?: string | null, upc?: string | null, volume?: string | null, weekFrom?: number | null, weekTo?: number | null, year?: number | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProduceTagsByTagCodesQueryVariables = Types.Exact<{
  tagCodes: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetProduceTagsByTagCodesQuery = { __typename?: 'Query', produceTagsByTagCodes?: { __typename?: 'ProduceTagsByTagCodesConnection', nodes?: Array<{ __typename?: 'MaterialItemDocument', id: string, tag?: { __typename?: 'MaterialItemTagData', tagCode: string } | null }> | null } | null };

export type GetSellableHardgoodsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialItemDocumentSortInput> | Types.MaterialItemDocumentSortInput>;
}>;


export type GetSellableHardgoodsQuery = { __typename?: 'Query', sellableHardgoods?: { __typename?: 'SellableHardgoodsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMaterialItemLocationQuantitiesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialItemLocationQuantityDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialItemLocationQuantityDocumentSortInput> | Types.MaterialItemLocationQuantityDocumentSortInput>;
}>;


export type GetMaterialItemLocationQuantitiesQuery = { __typename?: 'Query', materialItemLocationQuantities?: { __typename?: 'MaterialItemLocationQuantitiesConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialItemLocationQuantityDocument', id: string, locationId: string, materialItemId: string, quantity: number, siteLocationId: string, tenantId: string, updated: Types.TDateISO, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMaterialItemSiteLocationQuantitiesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialItemSiteLocationQuantityDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialItemSiteLocationQuantityDocumentSortInput> | Types.MaterialItemSiteLocationQuantityDocumentSortInput>;
}>;


export type GetMaterialItemSiteLocationQuantitiesQuery = { __typename?: 'Query', materialItemSiteLocationQuantities?: { __typename?: 'MaterialItemSiteLocationQuantitiesConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialItemSiteLocationQuantityDocument', id: string, materialItemId: string, quantity: number, siteLocationId: string, tenantId: string, updated: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCountReasonsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountReasonsQuery = { __typename?: 'Query', countReasons: Array<{ __typename?: 'CountReasonData', code: number, reason: string }> };

export type MaterialItemFragment = { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> };

export type ProduceTagFragment = { __typename?: 'MaterialItemDocument', erpId: string, id: string, quantityOnHand?: number | null, status: Types.MaterialItemStatus, updated: Types.TDateISO, tag?: { __typename?: 'MaterialItemTagData', category?: string | null, color?: string | null, customerName?: string | null, description?: string | null, extraCodes: Array<string>, fulfillItemCode?: string | null, genus?: string | null, retail?: number | null, series?: string | null, source: Types.ProduceTagSource, sku?: string | null, tagCode: string, tagId?: string | null, tagType?: string | null, upc?: string | null, volume?: string | null, weekFrom?: number | null, weekTo?: number | null, year?: number | null } | null };

export type MaterialItemLocationQuantityFragment = { __typename?: 'MaterialItemLocationQuantityDocument', id: string, locationId: string, materialItemId: string, quantity: number, siteLocationId: string, tenantId: string, updated: Types.TDateISO };

export type MaterialItemSiteLocationQuantityFragment = { __typename?: 'MaterialItemSiteLocationQuantityDocument', id: string, materialItemId: string, quantity: number, siteLocationId: string, tenantId: string, updated: Types.TDateISO };

export type VendorMaterialCostFragment = { __typename?: 'VendorMaterialCostDocument', effectiveDate?: Types.TDateISO | null, effectiveWeek?: number | null, effectiveYear?: number | null, id: string, isDefaultVendor: boolean, materialItemId: string, priceId?: string | null, revision: number, status: Types.MaterialPriceStatus, supplierRoyaltyPerEach?: number | null, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, tenantId: string, unitCost: number, unitCostText: string, updated: Types.TDateISO, vendorId: string };

export type MaterialTransactionFragment = { __typename?: 'MaterialTransactionDocument', id: string, materialItemId: string, itemName: string, locationId: string, locationName: string, toLocationId: string, toLocationName: string, countType: Types.MaterialItemCountType, transactionType: Types.MaterialTransactionType, quantity: number, previousQuantity: number, userEmail: string, reasonCode: string, vendorPurchaseOrderId: string, vendorName: string, purchaseOrderNumber: string, jobNumber?: number | null, lotNumber?: number | null, timestamp: Types.TDateISO };

export type GetMaterialTransactionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialTransactionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialTransactionDocumentSortInput> | Types.MaterialTransactionDocumentSortInput>;
}>;


export type GetMaterialTransactionsQuery = { __typename?: 'Query', materialTransactions?: { __typename?: 'MaterialTransactionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialTransactionDocument', id: string, materialItemId: string, itemName: string, locationId: string, locationName: string, toLocationId: string, toLocationName: string, countType: Types.MaterialItemCountType, transactionType: Types.MaterialTransactionType, quantity: number, previousQuantity: number, userEmail: string, reasonCode: string, vendorPurchaseOrderId: string, vendorName: string, purchaseOrderNumber: string, jobNumber?: number | null, lotNumber?: number | null, timestamp: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMaterialTransactionsPaginatedQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MaterialTransactionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MaterialTransactionDocumentSortInput> | Types.MaterialTransactionDocumentSortInput>;
}>;


export type GetMaterialTransactionsPaginatedQuery = { __typename?: 'Query', materialTransactions?: { __typename?: 'MaterialTransactionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MaterialTransactionDocument', id: string, materialItemId: string, itemName: string, locationId: string, locationName: string, toLocationId: string, toLocationName: string, countType: Types.MaterialItemCountType, transactionType: Types.MaterialTransactionType, quantity: number, previousQuantity: number, userEmail: string, reasonCode: string, vendorPurchaseOrderId: string, vendorName: string, purchaseOrderNumber: string, jobNumber?: number | null, lotNumber?: number | null, timestamp: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVendorMaterialCostsQueryVariables = Types.Exact<{
  materialItemId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.VendorMaterialCostDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetVendorMaterialCostsQuery = { __typename?: 'Query', vendorMaterialCosts?: { __typename?: 'VendorMaterialCostsConnection', totalCount: number, nodes?: Array<{ __typename?: 'VendorMaterialCostDocument', effectiveDate?: Types.TDateISO | null, effectiveWeek?: number | null, effectiveYear?: number | null, id: string, isDefaultVendor: boolean, materialItemId: string, priceId?: string | null, revision: number, status: Types.MaterialPriceStatus, supplierRoyaltyPerEach?: number | null, supplierRoyaltyPerEachText?: string | null, supplierRoyaltyStatus: Types.SupplierRoyaltyStatus, tenantId: string, unitCost: number, unitCostText: string, updated: Types.TDateISO, vendorId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type MyCountTaskFragment = { __typename?: 'MyCountTaskDocument', id: string, assignmentId: string, taskId: string, materialItemId: string, binLocationId: string, status: Types.CycleCountTaskStatus, expectedQty: number, overrideQty?: number | null, completedQty?: number | null, varianceReasonCode?: number | null, dueBy: Types.TDateISO, lastEventAt: Types.TDateISO };

export type MyAssignedCountTasksQueryVariables = Types.Exact<{
  status?: Types.InputMaybe<Types.CycleCountTaskStatus>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MyCountTaskDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MyCountTaskDocumentSortInput> | Types.MyCountTaskDocumentSortInput>;
}>;


export type MyAssignedCountTasksQuery = { __typename?: 'Query', myAssignedCountTasks?: { __typename?: 'MyAssignedCountTasksConnection', totalCount: number, nodes?: Array<{ __typename?: 'MyCountTaskDocument', id: string, assignmentId: string, taskId: string, materialItemId: string, binLocationId: string, status: Types.CycleCountTaskStatus, expectedQty: number, overrideQty?: number | null, completedQty?: number | null, varianceReasonCode?: number | null, dueBy: Types.TDateISO, lastEventAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type CycleCountAssignmentFieldsFragment = { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus, workerUserId?: string | null, tasks: Array<{ __typename?: 'CycleCountAssignmentTaskStateData', taskId: string }> };

export const MaterialItemFragmentDoc = new TypedDocumentString(`
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}
    `, {"fragmentName":"MaterialItem"});
export const ProduceTagFragmentDoc = new TypedDocumentString(`
    fragment ProduceTag on MaterialItemDocument {
  erpId
  id
  quantityOnHand
  status
  tag {
    category
    color
    customerName
    description
    extraCodes
    fulfillItemCode
    genus
    retail
    series
    source
    sku
    tagCode
    tagId
    tagType
    upc
    volume
    weekFrom
    weekTo
    year
  }
  updated
}
    `, {"fragmentName":"ProduceTag"});
export const MaterialItemLocationQuantityFragmentDoc = new TypedDocumentString(`
    fragment MaterialItemLocationQuantity on MaterialItemLocationQuantityDocument {
  id
  locationId
  materialItemId
  quantity
  siteLocationId
  tenantId
  updated
}
    `, {"fragmentName":"MaterialItemLocationQuantity"});
export const MaterialItemSiteLocationQuantityFragmentDoc = new TypedDocumentString(`
    fragment MaterialItemSiteLocationQuantity on MaterialItemSiteLocationQuantityDocument {
  id
  materialItemId
  quantity
  siteLocationId
  tenantId
  updated
}
    `, {"fragmentName":"MaterialItemSiteLocationQuantity"});
export const VendorMaterialCostFragmentDoc = new TypedDocumentString(`
    fragment VendorMaterialCost on VendorMaterialCostDocument {
  effectiveDate
  effectiveWeek
  effectiveYear
  id
  isDefaultVendor
  materialItemId
  priceId
  revision
  status
  supplierRoyaltyPerEach
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  tenantId
  unitCost
  unitCostText
  updated
  vendorId
}
    `, {"fragmentName":"VendorMaterialCost"});
export const MaterialTransactionFragmentDoc = new TypedDocumentString(`
    fragment MaterialTransaction on MaterialTransactionDocument {
  id
  materialItemId
  itemName
  locationId
  locationName
  toLocationId
  toLocationName
  countType
  transactionType
  quantity
  previousQuantity
  userEmail
  reasonCode
  vendorPurchaseOrderId
  vendorName
  purchaseOrderNumber
  jobNumber
  lotNumber
  timestamp
}
    `, {"fragmentName":"MaterialTransaction"});
export const MyCountTaskFragmentDoc = new TypedDocumentString(`
    fragment MyCountTask on MyCountTaskDocument {
  id
  assignmentId
  taskId
  materialItemId
  binLocationId
  status
  expectedQty
  overrideQty
  completedQty
  varianceReasonCode
  dueBy
  lastEventAt
}
    `, {"fragmentName":"MyCountTask"});
export const CycleCountAssignmentFieldsFragmentDoc = new TypedDocumentString(`
    fragment CycleCountAssignmentFields on CycleCountAssignmentStateData {
  assignmentId
  status
  workerUserId
  tasks {
    taskId
  }
}
    `, {"fragmentName":"CycleCountAssignmentFields"});
export const GetMaterialItemDocument = new TypedDocumentString(`
    query GetMaterialItem($materialItemId: String!) {
  materialItem(materialItemId: $materialItemId) {
    ...MaterialItem
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const GetMaterialItemsDocument = new TypedDocumentString(`
    query GetMaterialItems($first: Int, $after: String, $last: Int, $before: String, $where: MaterialItemDocumentFilterInput, $order: [MaterialItemDocumentSortInput!]) {
  materialItems(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...MaterialItem
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProduceTagsDocument = new TypedDocumentString(`
    query GetProduceTags($first: Int, $where: MaterialItemDocumentFilterInput, $order: [MaterialItemDocumentSortInput!]) {
  produceTags(first: $first, where: $where, order: $order) {
    nodes {
      ...ProduceTag
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProduceTag on MaterialItemDocument {
  erpId
  id
  quantityOnHand
  status
  tag {
    category
    color
    customerName
    description
    extraCodes
    fulfillItemCode
    genus
    retail
    series
    source
    sku
    tagCode
    tagId
    tagType
    upc
    volume
    weekFrom
    weekTo
    year
  }
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProduceTagsByTagCodesDocument = new TypedDocumentString(`
    query GetProduceTagsByTagCodes($tagCodes: [String!]!, $first: Int) {
  produceTagsByTagCodes(tagCodes: $tagCodes, first: $first) {
    nodes {
      id
      tag {
        tagCode
      }
    }
  }
}
    `);
export const GetSellableHardgoodsDocument = new TypedDocumentString(`
    query GetSellableHardgoods($first: Int, $after: String, $last: Int, $before: String, $where: MaterialItemDocumentFilterInput, $order: [MaterialItemDocumentSortInput!]) {
  sellableHardgoods(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...MaterialItem
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMaterialItemLocationQuantitiesDocument = new TypedDocumentString(`
    query GetMaterialItemLocationQuantities($first: Int, $after: String, $last: Int, $before: String, $where: MaterialItemLocationQuantityDocumentFilterInput, $order: [MaterialItemLocationQuantityDocumentSortInput!]) {
  materialItemLocationQuantities(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...MaterialItemLocationQuantity
      batches {
        ...InventoryBatchFields
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialItemLocationQuantity on MaterialItemLocationQuantityDocument {
  id
  locationId
  materialItemId
  quantity
  siteLocationId
  tenantId
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`);
export const GetMaterialItemSiteLocationQuantitiesDocument = new TypedDocumentString(`
    query GetMaterialItemSiteLocationQuantities($first: Int, $after: String, $last: Int, $before: String, $where: MaterialItemSiteLocationQuantityDocumentFilterInput, $order: [MaterialItemSiteLocationQuantityDocumentSortInput!]) {
  materialItemSiteLocationQuantities(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...MaterialItemSiteLocationQuantity
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialItemSiteLocationQuantity on MaterialItemSiteLocationQuantityDocument {
  id
  materialItemId
  quantity
  siteLocationId
  tenantId
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCountReasonsDocument = new TypedDocumentString(`
    query GetCountReasons {
  countReasons {
    code
    reason
  }
}
    `);
export const GetMaterialTransactionsDocument = new TypedDocumentString(`
    query GetMaterialTransactions($first: Int, $after: String, $where: MaterialTransactionDocumentFilterInput, $order: [MaterialTransactionDocumentSortInput!]) {
  materialTransactions(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...MaterialTransaction
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialTransaction on MaterialTransactionDocument {
  id
  materialItemId
  itemName
  locationId
  locationName
  toLocationId
  toLocationName
  countType
  transactionType
  quantity
  previousQuantity
  userEmail
  reasonCode
  vendorPurchaseOrderId
  vendorName
  purchaseOrderNumber
  jobNumber
  lotNumber
  timestamp
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMaterialTransactionsPaginatedDocument = new TypedDocumentString(`
    query GetMaterialTransactionsPaginated($first: Int, $after: String, $where: MaterialTransactionDocumentFilterInput, $order: [MaterialTransactionDocumentSortInput!]) {
  materialTransactions(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...MaterialTransaction
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialTransaction on MaterialTransactionDocument {
  id
  materialItemId
  itemName
  locationId
  locationName
  toLocationId
  toLocationName
  countType
  transactionType
  quantity
  previousQuantity
  userEmail
  reasonCode
  vendorPurchaseOrderId
  vendorName
  purchaseOrderNumber
  jobNumber
  lotNumber
  timestamp
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVendorMaterialCostsDocument = new TypedDocumentString(`
    query GetVendorMaterialCosts($materialItemId: String, $where: VendorMaterialCostDocumentFilterInput, $first: Int, $after: String) {
  vendorMaterialCosts(
    materialItemId: $materialItemId
    where: $where
    first: $first
    after: $after
  ) {
    nodes {
      ...VendorMaterialCost
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment VendorMaterialCost on VendorMaterialCostDocument {
  effectiveDate
  effectiveWeek
  effectiveYear
  id
  isDefaultVendor
  materialItemId
  priceId
  revision
  status
  supplierRoyaltyPerEach
  supplierRoyaltyPerEachText
  supplierRoyaltyStatus
  tenantId
  unitCost
  unitCostText
  updated
  vendorId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const MyAssignedCountTasksDocument = new TypedDocumentString(`
    query MyAssignedCountTasks($status: CycleCountTaskStatus, $first: Int, $after: String, $where: MyCountTaskDocumentFilterInput, $order: [MyCountTaskDocumentSortInput!]) {
  myAssignedCountTasks(
    status: $status
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...MyCountTask
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MyCountTask on MyCountTaskDocument {
  id
  assignmentId
  taskId
  materialItemId
  binLocationId
  status
  expectedQty
  overrideQty
  completedQty
  varianceReasonCode
  dueBy
  lastEventAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMaterialItem: build.query<GetMaterialItemQuery, GetMaterialItemQueryVariables>({
      query: (variables) => ({ document: GetMaterialItemDocument, variables })
    }),
    GetMaterialItems: build.query<GetMaterialItemsQuery, GetMaterialItemsQueryVariables | void>({
      query: (variables) => ({ document: GetMaterialItemsDocument, variables })
    }),
    GetProduceTags: build.query<GetProduceTagsQuery, GetProduceTagsQueryVariables | void>({
      query: (variables) => ({ document: GetProduceTagsDocument, variables })
    }),
    GetProduceTagsByTagCodes: build.query<GetProduceTagsByTagCodesQuery, GetProduceTagsByTagCodesQueryVariables>({
      query: (variables) => ({ document: GetProduceTagsByTagCodesDocument, variables })
    }),
    GetSellableHardgoods: build.query<GetSellableHardgoodsQuery, GetSellableHardgoodsQueryVariables | void>({
      query: (variables) => ({ document: GetSellableHardgoodsDocument, variables })
    }),
    GetMaterialItemLocationQuantities: build.query<GetMaterialItemLocationQuantitiesQuery, GetMaterialItemLocationQuantitiesQueryVariables | void>({
      query: (variables) => ({ document: GetMaterialItemLocationQuantitiesDocument, variables })
    }),
    GetMaterialItemSiteLocationQuantities: build.query<GetMaterialItemSiteLocationQuantitiesQuery, GetMaterialItemSiteLocationQuantitiesQueryVariables | void>({
      query: (variables) => ({ document: GetMaterialItemSiteLocationQuantitiesDocument, variables })
    }),
    GetCountReasons: build.query<GetCountReasonsQuery, GetCountReasonsQueryVariables | void>({
      query: (variables) => ({ document: GetCountReasonsDocument, variables })
    }),
    GetMaterialTransactions: build.query<GetMaterialTransactionsQuery, GetMaterialTransactionsQueryVariables | void>({
      query: (variables) => ({ document: GetMaterialTransactionsDocument, variables })
    }),
    GetMaterialTransactionsPaginated: build.query<GetMaterialTransactionsPaginatedQuery, GetMaterialTransactionsPaginatedQueryVariables | void>({
      query: (variables) => ({ document: GetMaterialTransactionsPaginatedDocument, variables })
    }),
    GetVendorMaterialCosts: build.query<GetVendorMaterialCostsQuery, GetVendorMaterialCostsQueryVariables | void>({
      query: (variables) => ({ document: GetVendorMaterialCostsDocument, variables })
    }),
    MyAssignedCountTasks: build.query<MyAssignedCountTasksQuery, MyAssignedCountTasksQueryVariables | void>({
      query: (variables) => ({ document: MyAssignedCountTasksDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMaterialItemQuery, useLazyGetMaterialItemQuery, useGetMaterialItemsQuery, useLazyGetMaterialItemsQuery, useGetProduceTagsQuery, useLazyGetProduceTagsQuery, useGetProduceTagsByTagCodesQuery, useLazyGetProduceTagsByTagCodesQuery, useGetSellableHardgoodsQuery, useLazyGetSellableHardgoodsQuery, useGetMaterialItemLocationQuantitiesQuery, useLazyGetMaterialItemLocationQuantitiesQuery, useGetMaterialItemSiteLocationQuantitiesQuery, useLazyGetMaterialItemSiteLocationQuantitiesQuery, useGetCountReasonsQuery, useLazyGetCountReasonsQuery, useGetMaterialTransactionsQuery, useLazyGetMaterialTransactionsQuery, useGetMaterialTransactionsPaginatedQuery, useLazyGetMaterialTransactionsPaginatedQuery, useGetVendorMaterialCostsQuery, useLazyGetVendorMaterialCostsQuery, useMyAssignedCountTasksQuery, useLazyMyAssignedCountTasksQuery } = injectedRtkApi;
